import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  ArrowLeft,
  FileText,
  Workflow,
  Sparkles,
  Code,
} from 'lucide-react';

// Builder tabs (excluding Canvas which has its own immersive UI, and Templates which is removed)
const builderTabs = [
  { value: 'form', label: 'Form', icon: FileText, href: '/agents/create/form' },
  { value: 'canvas', label: 'Canvas', icon: Workflow, href: '/agents/create/canvas' },
  { value: 'ai', label: 'AI Prompt', icon: Sparkles, href: '/agents/create/ai' },
  { value: 'json', label: 'JSON', icon: Code, href: '/agents/create/json' },
];

export const Route = createFileRoute('/_dashboard/agents/create')({
  component: CreateAgentLayout,
});

function CreateAgentLayout() {
  const location = useLocation();
  const pathname = location.pathname;

  // Canvas has its own immersive UI - just render the Outlet
  const isCanvasRoute = pathname === '/agents/create/canvas';
  if (isCanvasRoute) {
    return <Outlet />;
  }

  // Determine active tab from pathname
  const activeTab = builderTabs.find((tab) => pathname === tab.href)?.value || 'form';

  return (
    <div className="container max-w-6xl py-6 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/agents">
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Create Agent</h1>
          <p className="text-muted-foreground">Choose how you want to build your agent</p>
        </div>
      </div>

      {/* Builder Mode Tabs */}
      <Tabs value={activeTab}>
        <TabsList className="grid w-full grid-cols-4">
          {builderTabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} className="flex items-center gap-2" asChild>
              <Link to={tab.href}>
                <tab.icon className="h-4 w-4" />
                <span className="hidden sm:inline">{tab.label}</span>
              </Link>
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {/* Content */}
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
